module.exports = __webpack_public_path__ + "Ubuntu-LightItalic.d96027148c57a715e372.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-LightItalic.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-LightItalic.ttf
// module chunks = styles